import { render, staticRenderFns } from "./ZonasForm.vue?vue&type=template&id=53e2e0de&"
import script from "./ZonasForm.vue?vue&type=script&lang=js&"
export * from "./ZonasForm.vue?vue&type=script&lang=js&"
import style0 from "./ZonasForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports